import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const footerLinks = {
    movement: [
      { name: 'About CROWN', href: '/about' },
      { name: 'Our Vision', href: '/about' },
      { name: 'Core Beliefs', href: '/about' },
      { name: 'Resource Library', href: '/resources' }
    ],
    charters: [
      { name: 'Wealth Mastery', href: '/charters' },
      { name: 'Relationship Wholeness', href: '/charters' },
      { name: 'Generational Legacy', href: '/charters' },
      { name: 'All Forums', href: '/charters' }
    ],
    membership: [
      { name: 'Open Community', href: '/membership' },
      { name: 'Global Family', href: '/membership' },
      { name: 'Global Ambassadors', href: '/membership' },
      { name: 'Member Portal', href: '/portal' }
    ],
    connect: [
      { name: 'Contact Us', href: '/contact' },
      { name: 'Login', href: '/login' },
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Terms of Service', href: '/terms' }
    ]
  };

  const socialLinks = [
    { name: 'Facebook', icon: 'ri-facebook-fill', href: '#' },
    { name: 'Instagram', icon: 'ri-instagram-fill', href: '#' },
    { name: 'Twitter', icon: 'ri-twitter-x-fill', href: '#' },
    { name: 'LinkedIn', icon: 'ri-linkedin-fill', href: '#' },
    { name: 'YouTube', icon: 'ri-youtube-fill', href: '#' }
  ];

  const handleNavClick = (href: string) => {
    navigate(href);
  };

  return (
    <footer className="relative" style={{ background: '#3D2C8D' }}>
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-32 h-32 bg-gradient-to-r from-amber-400/10 to-yellow-300/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-24 h-24 bg-gradient-to-r from-amber-500/10 to-yellow-400/10 rounded-full blur-2xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center mb-6 group cursor-pointer" onClick={() => navigate('/')}>
              <div className="w-12 h-12 bg-gradient-to-r from-amber-400 to-yellow-300 rounded-xl flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-crown-line text-white text-2xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold" style={{ fontFamily: '"Playfair Display", serif', color: '#F5A623' }}>
                  CROWN
                </h3>
                <div className="text-xs text-white/80 -mt-1">House of CROWN</div>
              </div>
            </div>
            <p className="text-white/80 mb-8 leading-relaxed">
              Collaborative Restoration Of Wealth and Nations. Empowering global leaders to master wealth, relationships, and generational legacy.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className="w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-gradient-to-r hover:from-amber-400 hover:to-yellow-300 rounded-xl transition-all duration-300 cursor-pointer group"
                >
                  <i className={`${social.icon} text-xl text-white group-hover:scale-110 transition-transform duration-300`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-bold text-lg mb-6" style={{ color: '#F5A623' }}>Movement</h4>
            <ul className="space-y-3">
              {footerLinks.movement.map((link) => (
                <li key={link.name}>
                  <button 
                    onClick={() => handleNavClick(link.href)}
                    className="text-white/80 hover:text-amber-400 transition-colors duration-200 cursor-pointer text-left"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-6" style={{ color: '#F5A623' }}>Charters</h4>
            <ul className="space-y-3">
              {footerLinks.charters.map((link) => (
                <li key={link.name}>
                  <button 
                    onClick={() => handleNavClick(link.href)}
                    className="text-white/80 hover:text-amber-400 transition-colors duration-200 cursor-pointer text-left"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-6" style={{ color: '#F5A623' }}>Membership</h4>
            <ul className="space-y-3">
              {footerLinks.membership.map((link) => (
                <li key={link.name}>
                  <button 
                    onClick={() => handleNavClick(link.href)}
                    className="text-white/80 hover:text-amber-400 transition-colors duration-200 cursor-pointer text-left"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-6" style={{ color: '#F5A623' }}>Connect</h4>
            <ul className="space-y-3">
              {footerLinks.connect.map((link) => (
                <li key={link.name}>
                  <button 
                    onClick={() => handleNavClick(link.href)}
                    className="text-white/80 hover:text-amber-400 transition-colors duration-200 cursor-pointer text-left"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/60 text-sm">
            © 2024 The CROWN Abundance Movement. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 flex items-center space-x-6">
            <button 
              onClick={() => handleNavClick('/privacy')}
              className="text-white/60 hover:text-amber-400 text-sm transition-colors duration-200 cursor-pointer"
            >
              Privacy Policy
            </button>
            <button 
              onClick={() => handleNavClick('/terms')}
              className="text-white/60 hover:text-amber-400 text-sm transition-colors duration-200 cursor-pointer"
            >
              Terms of Service
            </button>
            <a 
              href="https://readdy.ai/?origin=logo" 
              className="text-white/60 hover:text-amber-400 text-sm transition-colors duration-200 cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
